<script setup lang="ts">
type Props = {
  productQuantity: number
}

defineProps<Props>()

const emit = defineEmits([
  'updateProductQuantity',
  'addToCart',
  'setIncreaseProduct',
  'setDecreaseProduct',
])

const addToCart = () => emit('addToCart')

const setIncreaseProduct = () => emit('setIncreaseProduct')

const setDecreaseProduct = () => emit('setDecreaseProduct')

onMounted(() => emit('updateProductQuantity'))
</script>

<template>
  <div class="product-detail-actions">
    <the-button
      v-if="!productQuantity"
      class="product-detail-actions__button"
      @click="addToCart"
    >
      Добавить
    </the-button>

    <the-counter
      v-else
      size="md"
      :value="productQuantity"
      @on-increase="setIncreaseProduct"
      @on-decrease="setDecreaseProduct"
    />
  </div>
</template>

<style lang="scss" scoped>
.product-detail-actions {
  &__button {
    width: 160px;
  }
}
</style>
